/*
         * @ngdoc function
         * @name ePay.Model:Session_ApplePaymentDataModel
         * @description
         * Model
         */
import { Session_AppleHeaderModel } from './Session_AppleHeaderModel';

export class Session_ApplePaymentDataModel {
  data: string | null | undefined;
  header: Session_AppleHeaderModel | null | undefined;
  signature: string | null | undefined;
  version: string | null | undefined;

	constructor(
		data?: string, 
		header?: Session_AppleHeaderModel, 
		signature?: string, 
		version?: string
	) {
		this.data = data || null;
		this.header = header || new Session_AppleHeaderModel();
		this.signature = signature || null;
		this.version = version || null;
	}
}
